module.exports = __webpack_public_path__ + "img/t5-2.bd62b375.svg";